export function formatText(val: string | undefined | null): string {
  return val === undefined ||
    val === null ||
    (typeof val === 'string' && val === '')
    ? '--'
    : val
}
